module.exports = __webpack_public_path__ + "static/media/12.0ab41d3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hats/12.png
// module id = 723
// module chunks = 0